import { normalizeModelMetadata } from '../utils/modelThinking';

const API_BASE_URL = 'https://api.vectorvault.io';
const MODEL_LIST_URL = `${API_BASE_URL}/model_list`;

export const extractDefaultModel = models => {
  const row = models.find(item => item.model?.toLowerCase() === 'default');
  if (!row) return '';
  if (typeof row.resolved_model === 'string' && row.resolved_model) return row.resolved_model;
  // Legacy /model_list responses stored the default model id in token_limit.
  return typeof row.token_limit === 'string' ? row.token_limit : '';
};

// Preserves the original fetchModelList contract (email param, catch-and-fallback-to-[]
// on failure) that Deploy.js and useModelManagement.js already depend on, while routing
// through the shared normalizer so both callers see the same dynamic thinking metadata.
export async function fetchModelList(email) {
  try {
    const response = await fetch(MODEL_LIST_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ secret_token: 'epic barrels for days', user: email }),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return normalizeModelMetadata(await response.json());
  } catch (error) {
    console.error('Error fetching model list:', error);
    return [];
  }
}

export const fetchModels = fetchModelList;

const modelAPI = { fetchModelList, fetchModels, extractDefaultModel };
export default modelAPI;
